import { Box, Paper, Typography, Stack, Divider } from '@mui/material';
import { memo, useMemo } from 'react';
import CustomTabs, { TabPanel } from '../../common/Tab/CustomTabs';
import ReportFrequencySelector from './ReportBy/ReportFrequencySelector';
import DisplayFieldGrid from './Display/DisplayFieldGrid';
import { displayFields, reportTypes } from '../../../Enums/Enum';


const RightDisplayPanel = ({
  tabs = [],
  selectedTab,
  onTabChange,
  selectedReportType,
  reportByTitle,
  onReportTypeChange,
  selectedFields = [],
  onToggleField,
  isMultiCorp = false,
}) => {
  const selectedReportLabel = reportTypes.find((rt) => rt.value === selectedReportType)?.label;
  const filteredDisplayFields = useMemo(() => {
    if (!isMultiCorp && selectedReportType === 'daily') {
      return displayFields.filter((f) =>
        ['punchIn', 'punchOut', 'scheduledHrs', 'actualHrs', 'overtimeHrs', 'varianceHrs', 'status'].includes(f.id)
      );
    }
    if (isMultiCorp && selectedReportType === 'daily') {
      return displayFields.filter((f) =>
        ['punchIn', 'punchOut', 'scheduledHrs', 'actualHrs', 'varianceOvertimeHrs', 'otPercent', 'otRisk'].includes(f.id)
      );
    }
    return displayFields.filter((f) =>
      ['scheduledHrs', 'actualHrs', 'overtimeHrs', 'varianceHrs', 'otPercent', 'otRisk'].includes(f.id)
    );
  }, [selectedReportType, isMultiCorp]);



  return (
    <Paper variant="outlined" sx={{ py: 0.25, height: '90vh', bgcolor: 'background.paper' }}>
      <CustomTabs value={selectedTab} tabs={tabs.map((tab) => ({ label: tab.label, value: tab.value }))} onChange={onTabChange} />
      <TabPanel value="view" selectedValue={selectedTab}>
        <Box sx={{ p: 2 }}>
          <Stack spacing={2}>
            <ReportFrequencySelector value={selectedReportType} title={reportByTitle} options={reportTypes} onChange={onReportTypeChange} />
            <Box>
              <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1, fontWeight: 'bold', fontSize: '14px' }}>
                {selectedReportLabel}
              </Typography>
              <Divider sx={{ borderColor: 'skyblue', borderBottomWidth: 3, mb: 1.5 }} />
              <DisplayFieldGrid fields={filteredDisplayFields} selectedFields={selectedFields} onToggleField={onToggleField} />
            </Box>
          </Stack>
        </Box>
      </TabPanel>
    </Paper>
  );
};

export default memo(RightDisplayPanel);
